import axios from "axios"

export const getAxiosInstanceApi = () => {
	return axios.create({
		baseURL: 'https://api.aref-medical.com',
		headers:{
			'x-center-token':'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZW50ZXJJZCI6IjE1Iiwicm9sZSI6InVzZXIiLCJpYXQiOjE2OTkwOTIzMTN9.GeqgwwLs3X6QdiPN36YIyul51AvBqsNqcCi62SnxUkw',
		}
	})
}
export const getReportInstanceApi = () => {
	return axios.create({
		baseURL: 'https://report.gy1.ir',
		headers:{
			'x-center-token':'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZW50ZXJJZCI6IjE1Iiwicm9sZSI6InVzZXIiLCJpYXQiOjE2OTkwOTIzMTN9.GeqgwwLs3X6QdiPN36YIyul51AvBqsNqcCi62SnxUkw',
		}
	})
}
export const getSurveyInstanceApi = () => {
    return axios.create({
        baseURL: 'https://api.salus.ir',
        headers: {
            "Content-Type": "application/json",
        },
    });
};